import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import questionCss from './Questions.scss'
import css from './EmailField.scss'
import Icon from 'SF/MaterialIcon';
import Input from './Input';
import { omit } from 'lodash'
import { isValidOrBlankEmail } from '../../utils/text';

const EmailField = (props) => {
  const { isReadOnly, questionText, hasError, ...rest } = props;
  const [isAlreadyEdited, setIsAlreadyEdited] = useState(false);
  const validateEmail = (value) => {
    if (isValidOrBlankEmail(value)) {
      props.setHasError(false);
    } else {
      props.setHasError(true);
    }
    setIsAlreadyEdited(true);
  }
  const changeHandler = (e) => {
    props.setValue(e.target.value)
  }
  
  useEffect(() => {
    isAlreadyEdited && validateEmail(props.value)
  }, [props.value]);

  const getEditableField = () => {
    const { value } = rest
    return (
      <Input
        {...omit(rest, ['setValue', 'setHasError', 'questionNumber'])}
        type="text"
        aria-label={questionText}
        value={value || ''}
        onChange={changeHandler}
        onBlur={(e) => validateEmail(e.target.value)}
        hasError={hasError}
      />
    );
  }

  const renderEmptyAnswerBlock = () => {
    return (
      <i>No answer provided</i>
    );
  }

  const getReadOnlyField = (value) => {
    return (
      <p className={css['email-input-answers']}>{value || renderEmptyAnswerBlock()}</p>
    );
  }

  return (
    <>
      <div>
        {isReadOnly ? getReadOnlyField(rest.value) : getEditableField()}
      </div>
      {!isReadOnly && hasError && (
        <div className={questionCss['input-error-message-block']} role="alert">
          <Icon icon="error" /><p>Please enter a valid email.</p>
        </div>
      )}
    </>
  );
}

EmailField.propTypes = {
  value: PropTypes.string,
  questionText: PropTypes.string,
  isReadOnly: PropTypes.bool,
  hasError: PropTypes.bool,
  setValue: PropTypes.func,
  setHasError: PropTypes.func
}
export default EmailField
